module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "title-box"
  }, [_c('h3', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.detailLan.detailText) + "  (" + _vm._s(_vm.queryObj.MODIFIED_ID) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "margin-top": "12px"
    }
  }, [_c('el-button', {
    staticClass: "preview-btn",
    attrs: {
      "type": "warning",
      "round": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.detailLan.goback) + "\n                ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "clear"
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel",
    attrs: {
      "element-loading-spinner": "el-icon-loading"
    }
  }, [(_vm.trData) ? _c('mtable', {
    attrs: {
      "thData": _vm.thData,
      "trData": _vm.trData,
      "page": _vm.page,
      "selPage": _vm.selPage,
      "tip": _vm.tip,
      "multiLanguage": _vm.detailLan,
      "jsonExcelAjax": _vm.jsonExcelAjax,
      "downLoadTran": _vm.downLoadTran,
      "name": _vm.name
    },
    on: {
      "tableChange": _vm.tableAjax
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41665074","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/CommissionSetting2/IB/IBReport/auditTrailDetailReport.vue
// module id = 1103
// module chunks = 1